import { useInvoiceSummary } from 'routes/Checkout/context/InvoiceSummary';
import { useSubmitOrder } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { parseErrorMessage } from 'routes/Checkout/context/SubmitOrder/utils';
import { useMenu } from 'components/MenuContext/MenuContext';
import { useCart } from 'hooks/context/cart';
import { Item } from 'olo-service';

export const useGetUnavailableItems = () => {
  const { error: invoiceSummaryError, postOrderError } = useInvoiceSummary();
  const { errorMessage: submitOrderErrorMessage } = useSubmitOrder();
  const { menu, loading: isMenuLoading } = useMenu();
  const { items: cartItems } = useCart();

  if (!cartItems.length) {
    return {
      hasUnavailableItems: false,
      unavailableItems: [],
      errorMessage: undefined,
      unavailableItemNames: []
    };
  }

  const parseItems = (message: string): string[] => {
    if (!message) return [];

    return message.slice(30).replace(' ', '').split(',');
  };

  const updateUnavailableItems = (key: string, value: Item, unavailableItemsList: string[]) => {
    if (unavailableItemsList.includes(key)) unavailableItemNames = [...unavailableItemNames, value.name];
  };

  const orderError = postOrderError ? submitOrderErrorMessage : undefined;
  const errorMessage = invoiceSummaryError ? parseErrorMessage(invoiceSummaryError) : orderError;
  const hasUnavailableItems = errorMessage && errorMessage.includes('item_not_available') ? true : false;
  const unavailableItems = parseItems(errorMessage);
  let unavailableItemNames: string[] = [];

  if (!isMenuLoading && menu) {
    for (const [key, value] of Object.entries(menu.items)) {
      updateUnavailableItems(key, value, unavailableItems);
    }
  }

  return {
    hasUnavailableItems,
    unavailableItems,
    errorMessage,
    unavailableItemNames,
  };
};
